<script>
import BListFilter from '@/components/forms/BListFilter.vue'


export default {
  name: 'TopicsFilter',
  functional: true,
  render: (h, context) => h(BListFilter, {
    ...context.data,
    props: {
      ...context.props,
      label: 'Поиск по названию и коду',
    },
  }),
}
</script>
